var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGotourl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Go-To_URL",
    "data-name": "Go-To URL",
    transform: "translate(-1059 -339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5561",
    "data-name": "Rectangle 5561",
    width: 24,
    height: 24,
    transform: "translate(1059 339)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-url-3028984",
    transform: "translate(1059.5 339.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65404",
    "data-name": "Group 65404",
    transform: "translate(2.5 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34365",
    "data-name": "Path 34365",
    d: "M18.228,13.144v1.6a3.5,3.5,0,0,1-3.5,3.5H7.743a3.5,3.5,0,0,1-3.5-3.5V7.767a3.5,3.5,0,0,1,3.5-3.5H9.325a4.647,4.647,0,0,1-.11-.884,3.527,3.527,0,0,1,.11-.884H7.743A5.259,5.259,0,0,0,2.5,7.767v6.979a5.243,5.243,0,0,0,5.243,5.248h6.972a5.243,5.243,0,0,0,5.243-5.248V13.162a4.1,4.1,0,0,1-.865.11A3.267,3.267,0,0,1,18.228,13.144Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34366",
    "data-name": "Path 34366",
    d: "M42.426,2.5H35.879A.878.878,0,0,0,35,3.378a.867.867,0,0,0,.878.878h4.444l-8.888,8.869a.85.85,0,0,0,0,1.225.871.871,0,0,0,.622.256.938.938,0,0,0,.622-.256l8.888-8.888V9.906a.878.878,0,0,0,.878.878.867.867,0,0,0,.878-.878V3.378A.894.894,0,0,0,42.426,2.5Z",
    transform: "translate(-25.828 -2.5)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotourl);
export default __webpack_public_path__ + "static/media/gotourl.51b257ef54e9eb034c8d8da94fa870d0.svg";
export { ForwardRef as ReactComponent };